// simple shared helpers for downloads (xlsx + csv)
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export function downloadExcel(data, filename = "report") {
  if (!data || !data.length) {
    return;
  }
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Report");
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${filename}.xlsx`);
}

export function downloadCSV(data, filename = "report") {
  if (!data || !data.length) return;
  const ws = XLSX.utils.json_to_sheet(data);
  const csv = XLSX.utils.sheet_to_csv(ws);
  saveAs(new Blob([csv], { type: "text/csv;charset=utf-8;" }), `${filename}.csv`);
}
